var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsEnum, IsObject, IsOptional, IsString, IsUUID } from 'class-validator';
import { Role } from '../../roles/index.js';
import { UserProfileDto } from '../../user/index.js';
import { CallPatientStatus } from '../../calls/enums/call-patient.enum.js';
import { AttendanceOutcome } from '../enums/attendance-outcome.enum.js';
import { CancellationOrigin } from '../enums/cancellation-origin.enum.js';
export class AppointmentParticipantResponseDto {
    id;
    createdAt;
    updatedAt;
    appointmentId;
    patientId;
    status;
    inviteToken;
    /**
     * Therapist-recorded outcome for this participant after the appointment
     * (TM-9071). `null` until the therapist confirms.
     */
    attendance;
    /**
     * Who cancelled this participation (TM-9737): the patient's Absage or a Praxisabsage.
     * Also set by a declined invitation, which is no Terminstatus — read it with
     * `attendance` or the appointment's `CANCELLED` status.
     */
    cancellationOrigin;
    /** When the cancellation counts from: for an Absage, when it reached the practice. */
    cancelledAt;
    patient;
}
__decorate([
    IsString(),
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], AppointmentParticipantResponseDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], AppointmentParticipantResponseDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], AppointmentParticipantResponseDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], AppointmentParticipantResponseDto.prototype, "appointmentId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose({ groups: [Role.ADMIN, Role.THERAPIST, Role.MANAGEMENT] }),
    __metadata("design:type", String)
], AppointmentParticipantResponseDto.prototype, "patientId", void 0);
__decorate([
    IsString(),
    Expose(),
    IsEnum(CallPatientStatus),
    __metadata("design:type", String)
], AppointmentParticipantResponseDto.prototype, "status", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Exclude(),
    __metadata("design:type", Object)
], AppointmentParticipantResponseDto.prototype, "inviteToken", void 0);
__decorate([
    IsEnum(AttendanceOutcome),
    IsOptional(),
    Expose({ groups: [Role.ADMIN, Role.THERAPIST, Role.MANAGEMENT] }),
    __metadata("design:type", Object)
], AppointmentParticipantResponseDto.prototype, "attendance", void 0);
__decorate([
    IsEnum(CancellationOrigin),
    IsOptional(),
    Expose({ groups: [Role.ADMIN, Role.THERAPIST, Role.MANAGEMENT] }),
    __metadata("design:type", Object)
], AppointmentParticipantResponseDto.prototype, "cancellationOrigin", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    Expose({ groups: [Role.ADMIN, Role.THERAPIST, Role.MANAGEMENT] }),
    __metadata("design:type", Object)
], AppointmentParticipantResponseDto.prototype, "cancelledAt", void 0);
__decorate([
    IsOptional(),
    IsObject(),
    Type(() => UserProfileDto),
    Expose({ groups: [Role.ADMIN, Role.THERAPIST, Role.MANAGEMENT] }),
    __metadata("design:type", Object)
], AppointmentParticipantResponseDto.prototype, "patient", void 0);
//# sourceMappingURL=appointment-participant.response.dto.js.map